import type { AbstractStepProps } from "@component/assets/AbstractLeadForm/Steps/AbstractStep";
import { AbstractStep } from "@component/assets/AbstractLeadForm/Steps/AbstractStep";
import { faEnvelope as farEnvelope } from "@awesome.me/kit-3777c2145e/icons/classic/regular";
import { faEnvelope as fasEnvelope } from "@awesome.me/kit-3777c2145e/icons/classic/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { formatText } from "@ui/format";
import { Button, List } from "bm-ui-kit";
import compact from "lodash/compact";
import type { ReactNode } from "react";
import React from "react";
import { Card } from "react-bootstrap";

export interface StepFields {}

interface Props extends AbstractStepProps {
	availabelSupport: number;
	babyLoanAmount: number;
	mortgageLoanAmount: number;
}

export class Result extends AbstractStep<StepFields, Props> {
	protected renderContent(): ReactNode {
		const { mortgageLoanAmount = 0 } = this.props;

		return (
			<>
				<Card.Header className="text-center mt-2">{this.renderHeader()}</Card.Header>
				<Card.Body className="d-flex flex-column">
					<hr className="my-2 w-100" />
					<div className="d-flex block-with-icon">
						<div className="text-center px-2">
							<FontAwesomeIcon icon={farEnvelope} className="text-gold" size="5x" />
						</div>
						<div className="px-2 text-white text-block">
							A részleteket <strong className="text-nowrap">e-mailben</strong> fogjuk elküldeni számodra!
						</div>
					</div>
					<hr className="my-2 w-100" />
					{this.renderList()}
				</Card.Body>
				{!!mortgageLoanAmount && (
					<Card.Header className="text-center mt-2 bg-info">
						Adataid alapján <strong>{formatText(mortgageLoanAmount, "ft")} lakáshitelt</strong> fel tudsz
						venni!
					</Card.Header>
				)}
				<Card.Footer className={`text-center${mortgageLoanAmount ? " bg-info" : ""}`}>
					<Button
						type="submit"
						variant="gold"
						icon={<FontAwesomeIcon icon={fasEnvelope} />}
						size="lg"
						className="text-uppercase"
					>
						Kérem a részleteket
					</Button>
				</Card.Footer>
			</>
		);
	}

	private renderHeader(): ReactNode {
		const { availabelSupport = 0, babyLoanAmount = 0 } = this.props;

		if (availabelSupport + babyLoanAmount === 0) {
			return "Sajnos nem vagy jogosult támogatás és Babaváró hitel igénybevételére!";
		}

		return (
			<>
				<div className="h1 mb-2 text-white font-weight-bold">
					{formatText(availabelSupport + babyLoanAmount, "ft")}
				</div>
				<div className="h3 text-uppercase mb-0 text-white font-weight-bold">
					{babyLoanAmount ? "Támogatás + Babaváró" : "Elérhető támogatás"}
				</div>
				az általad megadott adatok alapján
			</>
		);
	}

	private renderList(): ReactNode {
		const { availabelSupport = 0, babyLoanAmount = 0, mortgageLoanAmount = 0 } = this.props;

		if (availabelSupport + babyLoanAmount === 0) {
			return (
				<List itemStyle="tick" variant="gold" className=" my-auto">
					<List.Item>
						<strong>Miért nem vagy</strong> most jogosult támogatásra?
					</List.Item>
					<List.Item>
						<strong>Hogyan lehetnél</strong> jogosult?
					</List.Item>
					{!mortgageLoanAmount && (
						<List.Item>
							<strong>Szakértőink segítenek</strong> bármilyen kérdésedben!
						</List.Item>
					)}
				</List>
			);
		}

		return (
			<List itemStyle="tick" variant="gold" className="my-auto">
				<List.Item>
					<strong>Milyen elemekből</strong> áll össze a fenti támogatási összeg?
				</List.Item>
				<List.Item>
					<strong>Mennyi idő</strong> alatt és hogyan kaphatod meg?
				</List.Item>
				{!mortgageLoanAmount && (
					<List.Item>
						<strong>Szakértőink segítenek</strong> bármilyen kérdésedben!
					</List.Item>
				)}
			</List>
		);
	}

	protected getClassName(): string {
		return compact([super.getClassName(), "bg-success result-page"]).join(" ");
	}

	protected getComponentName(): string {
		return "Result";
	}
}
